module.exports = __webpack_public_path__ + "static/simple-bubble-67a1229592bc87087716ab4e6c50cfca.png";